import React, { useEffect, useState, useRef } from "react";
import { Grid, Button, CardContent, Stack, Card, Tooltip } from "@mui/material";
import "./style.css";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  useLocation
} from "react-router-dom";
import * as yup from "yup";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { ToastContainer } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import ValidationModal from "../common/ValidationModal"
import { Controller, useForm } from "react-hook-form";
import { useProjectApiClient } from "../../Services/api/projectService"

import { successToast, errorToast } from "../../utils/toast";
import SelectDropdown from "../common/FormSelectDropdown";
import TextInput from "../common/TextInput";
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import { useProcurementApiClient } from "../../Services/api/ProcurementService";
import { useLoader } from "../../../pages/LoaderContext";
import { projectVersion } from "config/navConfig";
import FileUpload from "../common/FileUpload";
import UploadList from "v2/components/common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";

const useStyles = makeStyles({
  themeButton: {
    backgroundColor: "#2a3fbf !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": { backgroundColor: "#2a3fbf !important" },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: "#d9d9d9 !important",
      color: "#626262 !important",
    },
  },
});

const schema = yup.object().shape({
  newRPM: yup.mixed().nullable(),
  supplier: yup.mixed().nullable(),
  singleSource: yup.mixed().nullable(),
  reachRisk: yup.mixed().nullable(),
  supplierSegmentation: yup.mixed().nullable(),
  partnerDrivenInnovation: yup.mixed().nullable(),
  sustainabilityElements: yup.string().nullable(),
  cmOnboarded: yup.mixed().nullable(),
  comment: yup.string().nullable(),
  risk: yup.mixed().nullable(),
});


interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const ProcurementForm: React.FC = () => {
  const location = useLocation();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const {
    getProjectDetails,
    getRequiredField,
    publishProjectOnSave,
    uploadProjectFile
  } = useProjectApiClient();

  const {
    getRisks,
    getCMOnboardedptions,
    getnewRPMOptions,
    getPartnerDrivenInnovationOptions,
    getSingleSourceOptions,
    getReachRiskOptions,
    createProcurement,
    getPRSupplier,
    getPRSupplierSegmentation,
    getProcurementDetailsById,
  } = useProcurementApiClient();

  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const [risks, setRisks] = useState([]);
  const [newRPM, setNewRPM] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [singleSource, setSingleSource] = useState([]);
  const [reachRisk, setReachRisk] = useState([]);
  const [supplierSegmentation, setSupplierSegmentation] = useState([]);
  const [partnerDrivenInnovation, setPartnerDrivenInnovation] = useState([]);
  let [cmOnboarded, setCMOnboarded] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const { loading, setLoading } = useLoader();
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  const [formData, setFormData] = useState({
    newRPM: "",
    supplier: "",
    singleSource: "",
    reachRisk: "",
    supplierSegmentation: "",
    partnerDrivenInnovation: "",
    sustainabilityElements: "",
    cmOnboarded: "",
    risk: "",
    comment: "",
  });

  const [initialformData, setInitialformData] = useState({
    newRPM: "",
    supplier: "",
    singleSource: "",
    reachRisk: "",
    supplierSegmentation: "",
    partnerDrivenInnovation: "",
    sustainabilityElements: "",
    cmOnboarded: "",
    risk: "",
    comment: "",
  });

  const {
    handleSubmit,
    control,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });


  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }

  }, [userData]);

  //  Fetch existing BC Information if editing

  useEffect(() => {
    const fetchOptions = async () => {
      await Promise.all([
        fetchPRSupplier(),
        fetchPRSupplierSegmentation(),
        fetchRisks(),
        fetchNewRPM(),
        fetchSingleSource(),
        fetchReachRisk(),
        fetchPartnerDrivenInnovation(),
        fetchCMOnboarded(),
        fetchsProjectDetails()
      ]);
    };
    fetchOptions();
    if (projectKey) {
      fetchProcurement(projectKey);
    }
  }, [projectKey]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);


  useEffect(() => {
    let check = JSON.stringify(formData) == JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }

  }, [formData]);

  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved });
        setIsDraftDisabled(data.issaved);
      }
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchRisks = async () => {
    try {
      const data = await getRisks();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name,
      }));
      // @ts-ignore
      setRisks(output);
    } catch (error) {
      console.error(" Failed to fetch Risk:", error);
    } finally {
    }
  };
  const fetchNewRPM = async () => {
    try {
      const data = await getnewRPMOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setNewRPM(output);
    } catch (error) {
      console.error(" Failed to fetch New RPM:", error);
    } finally {
    }
  };
  const fetchSingleSource = async () => {
    try {
      const data = await getSingleSourceOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setSingleSource(output);
    } catch (error) {
      console.error(" Failed to fetch New Goodies:", error);
    } finally {
    }
  };
  const fetchReachRisk = async () => {
    try {
      const data = await getReachRiskOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setReachRisk(output);
    } catch (error) {
      console.error(" Failed to fetch Locked Formulation:", error);
    } finally {
    }
  };
  const fetchPartnerDrivenInnovation = async () => {
    try {
      const data = await getPartnerDrivenInnovationOptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setPartnerDrivenInnovation(output);
    } catch (error) {
      console.error(" Failed to fetch Locked Formulation:", error);
    } finally {
    }
  };
  const fetchCMOnboarded = async () => {
    try {
      const data = await getCMOnboardedptions();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setCMOnboarded(output);
    } catch (error) {
      console.error(" Failed to fetch Locked Formulation:", error);
    } finally {
    }
  };
  const fetchPRSupplier = async () => {
    try {
      const data = await getPRSupplier();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setSupplier(output);
    } catch (error) {
      console.error(" Failed to fetch Format:", error);
    } finally {
    }
  };
  const fetchPRSupplierSegmentation = async () => {
    try {
      const data = await getPRSupplierSegmentation();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez,
      }));
      // @ts-ignore
      setSupplierSegmentation(output);
    } catch (error) {
      console.error(" Failed to fetch Pack Type:", error);
    } finally {
    }
  };

  const isEmptyObject = (obj: object) => {
    return JSON.stringify(obj) === '{}'
  };

  const fetchProcurement = async (key: string) => {
    try {
      setLoading(true)
      const response = await getProcurementDetailsById(projectKey);
      setLoading(false)
      // console.log(" Form Procurement Data response:", response);
      if (response && response.data) {
        const bcData = response.data; // Extract 'data' object from API response
        let procurementDetails = {
          newRPM: JSON.stringify(bcData.New_Rpm),
          supplier: JSON.stringify(bcData.Supplier_Key),
          singleSource: JSON.stringify(bcData.Single_Source),
          reachRisk: JSON.stringify(bcData.Reach_Risk),
          supplierSegmentation: JSON.stringify(bcData.Supplier_Segmentation_Key),
          partnerDrivenInnovation: JSON.stringify(bcData.Partner_Driven_Innovation),
          sustainabilityElements: bcData.Sustainability_Elements || "",
          cmOnboarded: JSON.stringify(bcData.CM_Onbaorded),
          comment: bcData.Comment || "",
          risk: JSON.stringify(bcData.Risk_Key),
        };
        setFormData(procurementDetails);
        setInitialformData(procurementDetails)

        //  Use `setValue` to update form fields in react-hook-form
        window.setTimeout(() => {
          Object.keys(procurementDetails).forEach((key) => {
            setValue(
              key as any,
              procurementDetails[key as keyof typeof procurementDetails]
            );
          });
        }, 100);

        // console.log(" Form Procurement Data Populated:", procurementDetails);
      }
    } catch (error) {
      console.error(" Failed to fetch  Procurement data:", error);
    }
  };

  //  Handle Form Change
  let handleFormChange = (name: string, value: any) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    hasAutoSaved.current = false;
  };

  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    hasAutoSaved.current = false;
  };

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved);
    }
  }

  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  //  Save or Update Data
  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if ((type === true) && (resField?.data && resField?.data.length)) {
      const groupedErrors = groupByModule(resField?.data);
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    try {
      let payload = {
        Project_Key: projectKey,
        New_Rpm: formData.newRPM,
        Supplier_Key: formData.supplier,
        Single_Source: formData.singleSource,
        Reach_Risk: formData.reachRisk,
        Supplier_Segmentation_Key: formData.supplierSegmentation,
        Partner_Driven_Innovation: formData.partnerDrivenInnovation,
        Sustainability_Elements: formData.sustainabilityElements,
        CM_Onbaorded: formData.cmOnboarded,
        Comment: formData.comment,
        Risk_Key: formData.risk,
      };
      console.log(payload, "Payload for Procurement Save/Update");

      let initialPayload = {
        Project_Key: projectKey,
        New_Rpm: initialformData.newRPM,
        Supplier_Key: initialformData.supplier,
        Single_Source: initialformData.singleSource,
        Reach_Risk: initialformData.reachRisk,
        Supplier_Segmentation_Key: initialformData.supplierSegmentation,
        Partner_Driven_Innovation: initialformData.partnerDrivenInnovation,
        Sustainability_Elements: initialformData.sustainabilityElements,
        CM_Onbaorded: initialformData.cmOnboarded,
        Comment: initialformData.comment,
        Risk_Key: initialformData.risk,
      };
      const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
      {/* @ts-ignore */ }

      payload.audit = completeAuditTrail;
      let res = await createProcurement(payload);
      if (type === true) {
        if (projectKey) {
          fetchProcurement(projectKey);
        }
        await pubLishProjectData();
        setProjectDetails({ issaved: true });
        setIsDraftDisabled(type)
      }
      updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
      successToast(res.message);

      setTimeout(() => {
        navigate(url ? url : `${projectVersion}/project/procurement/${projectId}/${projectKey}`);
      }, 3000);
    } catch (error) {
      console.error(" Error submitting form:", error);
    }
  };
  //  Save or Update Data in Draft
  const SaveDraft = async (url: string) => {
    if (!projectKey) {
      console.error("Error: Missing project_key in localStorage");
      return;
    }

    let payload = {
      Project_Key: projectKey,
      New_Rpm: formData.newRPM,
      Supplier_Key: formData.supplier,
      Single_Source: formData.singleSource,
      Reach_Risk: formData.reachRisk,
      Supplier_Segmentation_Key: formData.supplierSegmentation,
      Partner_Driven_Innovation: formData.partnerDrivenInnovation,
      Sustainability_Elements: formData.sustainabilityElements,
      CM_Onbaorded: formData.cmOnboarded,
      Comment: formData.comment,
      Risk_Key: formData.risk,
    };
    console.log(payload, "Payload for Procurement Draft");
    try {
      let res = await createProcurement(payload);
      if (res) {
        if (projectKey) {
          fetchProcurement(projectKey);
        }
        successToast(`Draft saved successfully!`);
        setTimeout(() => {
          navigate(url ? url : `${projectVersion}/project/sheq-sustainability/${projectId}/${projectKey}`);
          //  navigate(`${projectVersion}/project/sheq-sustainability/${projectId}/${projectKey}`);
        }, 3000);
      }
    } catch (error) {
      console.error(" Error saving draft:", error);
    }
  };

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    SaveDraft(appData.url)
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await SaveDraft('')
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 7, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };

  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "10px" }}>
          <CardContent>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?

                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button
                      disabled={isDisabled}
                      onClick={handleFormSubmit(true, '')}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: 'white !important',
                        backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}`
                      }}
                      className={classes.themeButton}
                    >
                      Submit
                    </Button>

                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={() => SaveDraft('')}
                      variant="contained"
                      sx={{
                        borderRadius: '30px',
                        px: 4,
                        py: 1,
                        textTransform: 'capitalize',
                        color: 'white !important',
                        backgroundColor: '#2a3fbf !important',
                        '&.Mui-disabled': {
                          backgroundColor: '#d9d9d9 !important',
                          color: '#5f6368 !important'
                        }
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button
                      disabled={isDisabled}
                      onClick={handleCancel}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                      }}
                      className={classes.cancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>

              }

            </div>
            {
              isUpload ?
                <>
                  {/* @ts-ignore */}
                  <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={7}></UploadList>
                </>
                :
                <form noValidate>
                  <Grid container spacing={3} sx={{ marginTop: '10px', }}>
                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        New RPM
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="newRPM"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("newRPM", val);
                                clearErrors("newRPM");
                              }}
                              options={newRPM}
                              isError={errors.newRPM ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.newRPM && (
                        <p className="error-message">{errors.newRPM.message}</p>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Supplier
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="supplier"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("supplier", val);
                                clearErrors("supplier");
                              }}
                              options={supplier}
                              isError={errors.supplier ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.supplier && (
                        <p className="error-message">{errors.supplier.message}</p>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Single Source
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="singleSource"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("singleSource", val);
                                clearErrors("singleSource");
                              }}
                              options={singleSource}
                              isError={errors.singleSource ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.singleSource && (
                        <p className="error-message">
                          {errors.singleSource.message}
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Reach Risk
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="reachRisk"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("reachRisk", val);
                                clearErrors("reachRisk");
                              }}
                              options={reachRisk}
                              isError={errors.reachRisk ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.reachRisk && (
                        <p className="error-message">{errors.reachRisk.message}</p>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Supplier Segmentation
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="supplierSegmentation"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("supplierSegmentation", val);
                                clearErrors("supplierSegmentation");
                              }}
                              options={supplierSegmentation}
                              isError={errors.supplierSegmentation ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.supplierSegmentation && (
                        <p className="error-message">
                          {errors.supplierSegmentation.message}
                        </p>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Partner Driven Innovation

                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="partnerDrivenInnovation"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("partnerDrivenInnovation", val);
                                clearErrors("partnerDrivenInnovation");
                              }}
                              options={partnerDrivenInnovation}
                              isError={
                                errors.partnerDrivenInnovation ? true : false
                              }
                            />
                          )}
                        />
                      </div>
                      {errors.partnerDrivenInnovation && (
                        <p className="error-message">
                          {errors.partnerDrivenInnovation.message}
                        </p>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={8}>
                      <label className="txt-label-input">Sustainability Elements</label>
                      <TextInput
                        isDisabled={isDisabled}
                        isComment={{ enabled: true, maxLength: 1000 }}
                        name="sustainabilityElements"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) =>
                          handleFormChange("sustainabilityElements", e.target.value)
                        }
                        multiline
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        CM Onboarded
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="cmOnboarded"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("cmOnboarded", val);
                                clearErrors("cmOnboarded");
                              }}
                              options={cmOnboarded}
                              isError={errors.cmOnboarded ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.cmOnboarded && (
                        <p className="error-message">
                          {errors.cmOnboarded.message}
                        </p>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={8}>
                      <label className="txt-label-input">Comment</label>
                      <TextInput
                        isDisabled={isDisabled}
                        className="comment-input" isComment={true}
                        name="comment"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) =>
                          handleFormChange("comment", e.target.value)
                        }
                        multiline
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <label className="txt-label-input">
                        Procurment Risk
                      </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="risk"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("risk", val);
                                clearErrors("risk");
                              }}
                              options={risks}
                              isError={errors.risk ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.risk && (
                        <p className="error-message">{errors.risk.message}</p>
                      )}
                    </Grid>
                  </Grid>
                </form>
            }

          </CardContent>
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />

    </>
  );
};

export default ProcurementForm;
